<template>
  <v-container fluid>
    <div class="py-4 px-2 d-flex justify-space-between">
      <div class="d-flex align-center">
        <span class="font-weight-medium">ฟีเจอร์ทั้งหมด</span>
      </div>
      <div class="d-flex align-center">
        <v-text-field
          v-model="search"
          label="ค้นหา"
          prepend-inner-icon="mdi-magnify"
          clearable
          flat
          solo
          dense
          hide-details
        ></v-text-field>
      </div>
    </div>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      loading-text="Loading... Please wait"
      :search="search"
      :headers="headers"
      :items="features"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
    >
      <template v-slot:item.limit_free_employee="{ item }">
        <span v-if="item.limit_free_employee === 0">0/0</span>
        <span v-else
          >{{
            item.employee_use > item.limit_free_employee
              ? item.limit_free_employee
              : item.employee_use
          }}/{{ item.limit_free_employee }}</span
        >
      </template>
      <template v-slot:item.limit_max_employee="{ item }">
        <span
          >{{ item.employee_use }}/{{
            item.limit_max_employee === 0 ? 'ไม่จำกัด' : item.limit_max_employee
          }}</span
        >
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src

export default {
  data() {
    return {
      sortBy: ['title_th'],
      sortDesc: [false],
      loading: true,
      search: '',
      headers: [
        {
          text: 'ชื่อฟีเจอร์',
          align: 'start',
          value: 'title_th',
        },
        {
          text: 'จำนวนพนักงานที่กำลังใช้งาน',
          align: 'center',
          value: 'employee_use',
        },
        {
          text: 'สิทธิ์การใช้งานฟรี',
          align: 'center',
          value: 'limit_free_employee',
        },
        {
          text: 'จำนวนผู้ใช้งานสูงสุด',
          align: 'center',
          value: 'limit_max_employee',
        },
      ],
    }
  },
  computed: {
    features() {
      return this.companyFeatures.map((com) => ({
        title_th: com.feature.title_th,
        limit_free_employee: com.limit_free_employee,
        limit_max_employee: com.limit_max_employee,
        employee_use: this.employeeFeatures.filter(
          (emp) => emp.feature.feature_uuid === com.feature.feature_uuid
        ).length,
      }))
    },
    companyFeatures() {
      return this.$store.state.feature.companyFeatures
    },
    employeeFeatures() {
      return this.$store.state.feature.employeeFeatures
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'ฟีเจอร์ทั้งหมด',
        disabled: true,
      },
    ])

    this.loadData()
  },
  methods: {
    ...mapActions({
      fetchCompanyFeatures: 'feature/fetchCompanyFeatures',
      fetchEmployeeFeatures: 'feature/fetchEmployeeFeatures',
    }),
    loadData() {
      const { company_uuid } = this.$store.state.authentication.company

      const employeeFeatures = this.fetchEmployeeFeatures(company_uuid)
      const companyFeatures = this.fetchCompanyFeatures({
        company_uuid,
        is_active: true,
      })

      Promise.all([employeeFeatures, companyFeatures])
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
  },
}
</script>
